export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
  version="1.1"
>
  <path
     d="m 6.7282521,0.73462495 a 3.4076224,1.1358742 0 0 0 0,1.13586705 0.90870129,1.1358766 0 0 1 0,2.2717531 3.4076224,1.1358742 0 0 0 -3.407623,1.1358766 V 16.636857 a 5.679371,1.1358742 0 1 0 11.3587419,0 V 5.2781217 a 3.4076224,1.1358742 0 0 0 -3.407623,-1.1358766 0.90870129,1.1358766 0 0 1 0,-2.2717531 3.4076224,1.1358742 0 0 0 0,-1.13586705 2.726098,1.1358742 0 0 0 -4.5434959,0"
     style="fill:none;stroke:currentColor;stroke-width:0.453258;stroke-dasharray:none;stroke-opacity:1" />
</svg>`;
